import waiter from '@/store/utils/waiter';

export default {
  async archive({
    dispatch,
    getters,
    commit,
  }, offerId) {
    await waiter('privateOffers/table', {
      dispatch,
      commit,
    }, async () => {
      await getters.getRepository.archive(offerId);
    });
  },

  async unarchive({
    dispatch,
    getters,
    commit,
  }, offerId) {
    await waiter('privateOffers/table', {
      dispatch,
      commit,
    }, async () => {
      await getters.getRepository.unarchive(offerId);
    });
  },

  async complete({
    dispatch,
    getters,
    commit,
  }, offerId) {
    await waiter('privateOffers/table', {
      dispatch,
      commit,
    }, async () => {
      await getters.getRepository.complete(offerId);
    });
  },
};
